/**
 * CSGCombiner - blank CSG root node for top-level CSG hierarchy containers.
 * Produces no geometry of its own; combines children via boolean operations.
 * Similar to Godot's CSGCombiner3D.
 */
import { CollisionMeshType, PhysicsMotionType } from '../../physics/PhysicsTypes.js';
import { EngineClass } from '../../systems/ClassRegistry.js';
import { property } from '../../utils/serialization/decorator.js';

import { CSGComponent } from './CSGComponent.js';

import type { CSGComponentOptions } from './CSGComponent.js';
import type { ComponentPhysicsOptions } from '../../physics/PhysicsTypes.js';
import type { EditorPropertyChangedResult } from '../../utils/EditorClassMeta.js';


export interface CSGCombinerOptions extends CSGComponentOptions {
  /** Physics options for the generated mesh */
  physicsOptions?: ComponentPhysicsOptions;
}

/** Empty CSGComponent that acts as a CSG root. Owns the generated result mesh. */
@EngineClass('CSGCombiner')
export class CSGCombiner extends CSGComponent<CSGCombinerOptions> {

  // TODO LRK: Marking this hidden feels like a hack?
  @property({ hidden: true })
  protected override physicsOptions: ComponentPhysicsOptions = {
      enabled: true,
      motionType: PhysicsMotionType.Static,
      collisionMeshType: CollisionMeshType.Trimesh,
    };

  public override initialize(options?: CSGCombinerOptions): void {
    super.initialize(options);
    this.physicsOptions = options?.physicsOptions ?? this.physicsOptions;
  }

  public override onEditorPropertyChanged(path: string, value: any, result: EditorPropertyChangedResult): void {
    super.onEditorPropertyChanged(path, value, result);
    this.processCSG();
  }

  //====================================================================================================
  // Editor Functions
  //====================================================================================================

  public override getEditorClassIcon(): string | null {
    return 'Icon_CSGCombiner';
  }
}
